// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_k9-6";
export var emphasizeQuantity = "_k9-3";
export var flatBottomCorners = "_k9-5";
export var productImage = "_k9-0";
export var quantityContainer = "_k9-2";
export var tooltip = "_k9-1";
export var wrapAndEllipsesOverflow = "_k9-4";